<template>
  <div>
    <duo-paper-cut
      :width="width"
      :height="height"
      :srcList="srcList"
      :autoPlay="autoPlay"
      :interval="interval"
      :transition="transition"
      :cutsNumber="cutsNumber"
      :paginationDirection="paginationDirection"
    />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      width: 800,
      height: 460,
      cutsNumber: 18,
      interval: 4500,
      autoPlay: true,
      transition: 1500,
      paginationDirection: "left-bottom",
      srcList: [
        "https://goss.cfp.cn/static/home/h2_5.png",
        "http://d300.paixin.com/thumbs/1739009/19194001/staff_1024.jpg",
        "https://goss.cfp.cn/static/home/h2_6.png",
        "http://d300.paixin.com/thumbs/1067920/20205975/staff_1024.jpg",
      ],
    };
  },
};
</script>


<style>
HTML {
  background: #000000;
}
* {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue